import * as Styled from '../BusinessProcessTree.styled';
import { InfoButton } from './InfoButton';

export const renderEvdNode = (node: any, level: number, token: any) => {
  const item = node.raw;

  const TYPES = ['bru', 'solution', 'evidence'] as const;

  const type = TYPES[level];

  return (
    <Styled.TreeNodeWrapper>
      <Styled.TreeLabel token={token}>{type.toUpperCase()}</Styled.TreeLabel>

      <Styled.TreeValue token={token} level={level}>
        {node.label}

        {type === 'evidence' && <InfoButton type='evidence' item={item} />}
      </Styled.TreeValue>
    </Styled.TreeNodeWrapper>
  );
};
